import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import AppWithAuth from './AppWithAuth';
import theme from './theme';
import './components/input/JsonEditor.css';
import './components/pipeline/dashboard/PipelinesDashboard.css';

const LOCAL_STORAGE_EXPECTED_VERSION = '1';
const LOCAL_STORAGE_VERSION_KEY = 'mybuildsimple-storage-version';
const localStorageVersion = localStorage.getItem(LOCAL_STORAGE_VERSION_KEY) || undefined;
if (!localStorageVersion || localStorageVersion !== LOCAL_STORAGE_EXPECTED_VERSION) {
  localStorage.removeItem('amplify-authenticator-authState');
  localStorage.removeItem('tenant-appClient');
}
localStorage.setItem(LOCAL_STORAGE_VERSION_KEY, LOCAL_STORAGE_EXPECTED_VERSION);

ReactDOM.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      <AppWithAuth />
    </ThemeProvider>
  </StyledEngineProvider>,
  document.getElementById('root')

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
